const groupeReducer = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_GROUPE':
      return action.data
    default:
      return state
  }
}

export default groupeReducer
